'use client';
import dynamic from 'next/dynamic';
import { useRef, useState, useEffect } from 'react';

const DynamicMap = dynamic(() => import('@/app/_components/widgets/map/interactive'), {
  ssr: false,
  loading: () => null,
});

const MapStaticToInteractive = ({ items, alt = 'Mappa' }: { items: any[]; alt?: string }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    console.log('useEffect', el);
    console.log('el', el);
    const io = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          setIsInView(true);
          io.disconnect();
        }
      },
      { rootMargin: '400px 0px' }, // pre-carica un po' prima
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  if (!isInView) {
    return <div ref={ref}></div>;
  }

  return <DynamicMap items={items} setUserGeolocation={() => {}} isUserGeolocationActive={false} />;
};

export default MapStaticToInteractive;
